/* MonKoku Maison · leichte Interaktionen (keine Scroll-Listener) */
(function () {
  'use strict';
  window.__mkOK = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var SEL = '.product-card, .footer__block, [data-mk-rv]';
  var io = null, cio = null;

  function showAll(list) { list.forEach(function (el) { el.classList.add('is-in'); }); }

  function count(el) {
    var end = parseInt(String(el.getAttribute('data-mk-count')).replace(/\D/g, ''), 10);
    if (!end || reduce) return;
    var t0 = null, dur = 1500;
    function step(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * e).toLocaleString('de-DE');
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  function arm(root) {
    var scope = root || document;
    var list = Array.prototype.slice.call(scope.querySelectorAll(SEL));
    var counters = Array.prototype.slice.call(scope.querySelectorAll('[data-mk-count]'));
    if (!hasIO || reduce) { showAll(list); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
      cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { count(en.target); cio.unobserve(en.target); }
        });
      }, { threshold: 0.6 });
    }
    var vh = window.innerHeight || 800;
    list.forEach(function (el, i) {
      if (el.hasAttribute('data-mk-seen')) return;
      el.setAttribute('data-mk-seen', '');
      var isStatic = el.hasAttribute('data-mk-rv');
      if (!isStatic) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.95 && r.bottom > 0) return; /* schon sichtbar: nicht ausblenden */
        el.setAttribute('data-mk-rv', '');
        el.style.setProperty('--mk-d', ((i % 4) * 0.08).toFixed(2) + 's');
      }
      io.observe(el);
    });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* Lange Texte (Kollektionsbeschreibung) einklappen */
  function clamp(scope) {
    (scope || document).querySelectorAll('[data-mk-clamp]').forEach(function (box) {
      var btn = box.parentNode && box.parentNode.querySelector('[data-mk-more]');
      if (!btn) return;
      var over = box.scrollHeight > box.clientHeight + 4;
      if (!box.classList.contains('is-open')) box.classList.toggle('is-clamped', over);
      if (over || box.classList.contains('is-open')) btn.hidden = false;
      if (btn.hasAttribute('data-mk-bound')) return;
      btn.setAttribute('data-mk-bound', '');
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var o = box.classList.toggle('is-open');
        if (o) box.classList.remove('is-clamped');
        btn.textContent = o ? 'Weniger anzeigen' : 'Mehr lesen';
        btn.setAttribute('aria-expanded', o ? 'true' : 'false');
      });
    });
  }

  /* Footer: "Wissen" auf Desktop immer offen */
  function foot() {
    var big = window.matchMedia && window.matchMedia('(min-width: 900px)').matches;
    document.querySelectorAll('details.mk-fcol').forEach(function (d) {
      if (big) d.setAttribute('open', '');
    });
  }

  function ready() {
    arm(document); clamp(document); foot();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { clamp(document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); clamp(e.target); foot(); });

  /* Code antippen: Aktion im Warenkorb hinterlegen, bestehende Codes bleiben erhalten */
  if (!window.customElements.get('mk-arm')) {
    class MkArm extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.run.bind(this));
        this.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.run(e); }
        }.bind(this));
      }
      async run(ev) {
        ev.preventDefault();
        if (this.hasAttribute('busy')) return;
        var code = this.getAttribute('code') || '';
        if (!code) return;
        this.setAttribute('busy', '');
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var label = this.querySelector('[data-mk-arm-label]');
        var base = this.getAttribute('data-label') || (label && label.textContent) || '';
        try {
          var cart = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
          var codes = (cart.discount_codes || []).map(function (c) { return c.code; });
          var has = codes.some(function (c) { return c.toUpperCase() === code.toUpperCase(); });
          if (!has) codes.push(code);
          var res = await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          });
          if (!res.ok) throw new Error('http');
          this.classList.add('is-armed');
          if (label) label.textContent = this.getAttribute('data-done') || 'Aktiviert';
          this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (e) {
          try { await navigator.clipboard.writeText(code); } catch (_) {}
          if (label) label.textContent = 'Code kopiert';
        } finally {
          this.removeAttribute('busy');
          var self = this;
          setTimeout(function () {
            if (label && !self.classList.contains('is-armed')) label.textContent = base;
          }, 2600);
        }
      }
    }
    window.customElements.define('mk-arm', MkArm);
  }
})();